import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

function Menu() {
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);
    const [username, setusername] = useState("");
    const [role, setrole] = useState("");

    // submenu state
    const [openAccount, setOpenAccount] = useState(false);
    const [openReport, setOpenReport] = useState(false);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData1();
        });
        // eslint-disable-next-line
    }, [userData]);

    const fetchData1 = async () => {
        try {
            if (userData && loadincount) {
                const docRef = doc(db, "users", userData.uid);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setrole(docSnap.data().role);
                    setusername(docSnap.data().username);
                    setloadincount(false);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4" style={{ background: "linear-gradient(180deg,#2c3e50,#34495e)" }}>
            {/* Brand Logo */}
            <a href="/home" className="brand-link">
                <img src={window.location.origin + '/user.jpg'} alt="Logo" className="brand-image img-circle elevation-3" style={{ opacity: '.8' }} />
                <span className="brand-text font-weight-light">{username}</span>
            </a>

            {/* Sidebar */}
            <div className="sidebar">
                <nav className="mt-2">
                    <ul className="nav nav-pills nav-sidebar flex-column" role="menu">

                        {/* Home */}
                        <li className="nav-item">
                            <a href="/home" className="nav-link">
                                <i className="nav-icon fas fa-home" />
                                <p>Home</p>
                            </a>
                        </li>

                        {/* DCR Report */}
                        <li className="nav-item">
                            <a href="/dcr-report" className="nav-link">
                                <i className="nav-icon fas fa-file-alt" />
                                <p>DCR Report</p>
                            </a>
                        </li>

                        {/* <li className="nav-item">
                            <a href="/daily-cash-report" className="nav-link">
                                <i className="nav-icon fas fa-file-alt" />
                                <p>Daily Cash Report Excell</p>
                            </a>
                        </li> */}

                        {/* Staff Mgmt */}
                        <li className="nav-item">
                            <a href="/staff-details" className="nav-link">
                                <i className="nav-icon fas fa-users" />
                                <p>Staff Details</p>
                            </a>
                        </li>
                        
                        <li className="nav-item">
                            <a href="/staff-category" className="nav-link">
                                <i className="nav-icon fas fa-list-alt" />
                                <p>Staff Category</p>
                            </a>
                        </li>

                         <li className="nav-item">
                            <a href="/extra-service-details" className="nav-link">
                                <i className="nav-icon fas fa-list" />
                                <p>Extra Service</p>
                            </a>
                        </li>

                        {/* Account Mgmt with Submenu */}
                        <li className={`nav-item ${openAccount ? "menu-open" : ""}`}>
                            <a href="#0" className="nav-link" onClick={() => setOpenAccount(!openAccount)}>
                                <i className="nav-icon fas fa-credit-card" />
                                <p>
                                    Account Mgmt
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            {openAccount && (
                                <ul className="nav nav-treeview">
                                    <li className="nav-item">
                                        <a href="/expense-heads" className="nav-link">
                                            <i className="far fa-circle nav-icon" />
                                            <p>Expense Head</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/add-expense" className="nav-link">
                                            <i className="far fa-circle nav-icon" />
                                            <p>Add Expense</p>
                                        </a>
                                    </li>
                                </ul>
                            )}
                        </li>

                         <li className="nav-item">
                            <a href="/terij-patrak" className="nav-link">
                                <i className="nav-icon fas fa-table" />
                                <p>Terij Patrak</p>
                            </a>
                        </li>

                        
                        {/* Reports with Submenu */}
                        <li className={`nav-item ${openReport ? "menu-open" : ""}`}>
                            <a href="#0" className="nav-link" onClick={() => setOpenReport(!openReport)}>
                                <i className="nav-icon fas fa-chart-bar" />
                                <p>
                                    Reports
                                    <i className="right fas fa-angle-left" />
                                </p>
                            </a>
                            {openReport && (
                                <ul className="nav nav-treeview">
                                    <li className="nav-item">
                                        <a href="/all-booking-report" className="nav-link">
                                            <i className="far fa-circle nav-icon" />
                                            <p>All Booking Report</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/collection-report" className="nav-link">
                                            <i className="far fa-circle nav-icon" />
                                            <p>All Collection Report</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/paymode-checkout-history" className="nav-link">
                                            <i className="far fa-circle nav-icon" />
                                            <p>Paymode Checkout History</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/pending-report" className="nav-link">
                                            <i className="far fa-circle nav-icon" />
                                            <p>All Pending Payment</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/checkout-report" className="nav-link">
                                            <i className="far fa-circle nav-icon" />
                                            <p>Checkout Report</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/room-type-wise-online-bookings" className="nav-link">
                                            <i className="far fa-circle nav-icon" />
                                            <p>Room Type Wise Online</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/receptionist-report" className="nav-link">
                                            <i className="far fa-circle nav-icon" />
                                            <p>Receptionist Report</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/roomtypewise-bookings" className="nav-link">
                                            <i className="far fa-circle nav-icon" />
                                            <p>Room Typewise Booking</p>
                                        </a>
                                    </li>
                                </ul>
                            )}
                        </li>
                    </ul>
                </nav>
            </div>
        </aside>
    );
}

export default Menu;
